import { COLLISION_CELLS_PER_TILE } from "../document/types.ts";
import { standingDepth } from "./sort.ts";

/**
 * The player wash's layout (ADR-071 decision 3): one strip per collision cell row of a map, each at the
 * depth of a character standing half a pixel above the row's bottom edge, so whatever sorts over a
 * character on that row draws over its strip and whatever such a character covers is tinted by it.
 */

/**
 * One strip of the wash, in world pixels.
 */
export interface WashRow {
  readonly top: number;
  readonly height: number;
  readonly depth: number;
}

/**
 * The wash's strips, top to bottom.
 *
 * @param mapHeight Map height in tiles.
 * @param tileSize Tile size in pixels.
 * @param band The Players band, the number of ground layers.
 * @returns `mapHeight * COLLISION_CELLS_PER_TILE` strips, one cell row high each.
 */
export function washRows(mapHeight: number, tileSize: number, band: number): WashRow[] {
  const cell = tileSize / COLLISION_CELLS_PER_TILE;
  const rows: WashRow[] = [];
  for (let i = 0; i < mapHeight * COLLISION_CELLS_PER_TILE; i += 1) {
    rows.push({ top: i * cell, height: cell, depth: standingDepth((i + 1) * cell - 0.5, tileSize, band, mapHeight) });
  }
  return rows;
}
